import React, { useCallback, useEffect, useState, useRef } from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'dva';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { history } from 'umi';
import ClearIcon from '@material-ui/icons/Clear';
import dayjs from 'dayjs';
import { DatePicker } from '@material-ui/lab';
import AddStyled from './AddStyled';
import CampaignEquity from './campaignEquity/CampaignEquity';
import BaseInformation from './base_information/BaseInformation.jsx';
import ButtonGroup from './button_group/ButtonGroup';

const Add = () => {
  //国际化
  // const intl = useIntl();
  // const { formatMessage } = intl;
  const methods = useForm();
  const dispatch = useDispatch();
  const { handleSubmit, control, register, errors, setValue, getValues } =
    useForm({});
  //获取参数
  const { status, cardType, id, detailId } = history?.location?.query || {};
  //编辑时拿到当前数据详情
  const activityGroupDetail =
    useSelector((state) => state.crowdAddCoupon?.activityInfo) || null;

  //用户选择优惠券信息
  const [couponList, setCouponList] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [contentValue, setContentValue] = React.useState('COUPON');
  const saveRef = useRef();
  const { manualOperationCouponChooseData, failureOperationCouponChooseData } =
    useSelector((state) => state.crowdAddCoupon);

  // 获取优惠券详情信息
  const fetchCouponDetail = useCallback(() => {
    !isNaN(detailId) &&
      detailId &&
      dispatch({
        type: 'crowdAddCoupon/getCouponDetail',
        payload: {
          values: {
            id: detailId,
          },
        },
        callback: (res) => {
          const list = res.data.couponInfo;
          setCouponList(list);
          setValue('remark', res.data.remark);
        },
      });
  }, [dispatch, detailId, setValue]);
  useEffect(() => {
    fetchCouponDetail();
  }, [fetchCouponDetail]);

  // 获取会员基本详情信息
  const fetchMemberDetail = useCallback(() => {
    id &&
      dispatch({
        type: 'crowdAddCoupon/getMemberDetail',
        payload: {
          values: {
            memberID: id,
          },
        },
      });
  }, [dispatch, id]);
  useEffect(() => {
    fetchMemberDetail();
  }, [fetchMemberDetail]);
  const memberDetail = useSelector((state) => {
    return state?.crowdAddCoupon?.memberDetail;
  });

  const handleSubmitFailed = () => {};
  console.log('manualOperationCouponData', manualOperationCouponChooseData);
  //关于新增人群
  const handleSubmitSuccess = (data) => {
    if (contentValue === 'COUPON' && couponList.length === 0) {
      window.message.toast({
        type: 'error',
        message: '未选择优惠券',
        title: '',
      });
      return false;
    }
    if (
      contentValue === 'COUPON_BIND_TIME' &&
      manualOperationCouponChooseData.length === 0
    ) {
      window.message.toast({
        type: 'error',
        message: '至少选择一张有效优惠券',
        title: '',
      });
      return false;
    }
    if (
      contentValue === 'COUPON_BIND_STATUS' &&
      failureOperationCouponChooseData.length === 0
    ) {
      window.message.toast({
        type: 'error',
        message: '至少选择一张有效优惠券',
        title: '',
      });
      return false;
    }

    const { memberCode } = history?.location?.query || {};
    let values = {
      couponSourceType: contentValue === 'COUPON' ? 'JOB_APPROVAL' : null,
      memberCode,
      memberId: id,
      coupons: couponList,
      remark: data?.remark,
      couponChange:
        contentValue === 'COUPON_BIND_STATUS'
          ? failureOperationCouponChooseData
          : manualOperationCouponChooseData,
      type: contentValue,
      startTime: data?.startTimeChecked ? `${data?.startTime} 00:00:00` : null,
      endTime: data?.endTimeChecked ? `${data?.endTime} 23:59:59` : null,
    };
    window.NE_DAWN.trigger(saveRef.current, {
      event: '_ec', // 事件名
      params: { ...values }, // 事件公参
    });
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    dispatch({
      type: 'crowdAddCoupon/postManualOperation',
      payload: {
        values,
      },
      callback: (res) => {
        if (res.code !== 0) {
          setIsSubmit(false);
          return;
        }
        window.message.toast({
          type: 'success',
          message:
            contentValue === 'COUPON'
              ? '发放优惠券成功'
              : contentValue === 'COUPON_BIND_TIME'
              ? '优惠券有效期调整成功'
              : '优惠券失效调整成功',
          title: '',
        });
        setTimeout(() => {
          setIsSubmit(false);
          history.goBack();
        }, 2000);
      },
    });
  };

  const remarkLabel = contentValue !== 'COUPON' ? '调整原因' : '发放原因';
  return (
    <AddStyled>
      <BaseInformation memberDetail={memberDetail} />
      <Box
        data-log={JSON.stringify({
          oid: 'page_manual_adjustment_member_coupon',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <FormProvider {...methods}>
          <form
            onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFailed)}
          >
            <Box className="form-wrapper">
              <CampaignEquity
                // data={initDataTables(couponsChooseItemShowIdData, couponPage)}
                cardType={cardType}
                status={status}
                control={control}
                activityGroupDetail={activityGroupDetail}
                setValues={setValue}
                couponList={couponList}
                setCouponList={setCouponList}
                register={register}
                errors={errors}
                getValues={getValues}
                setContentValue={setContentValue}
                contentValue={contentValue}
              />
              {contentValue === 'COUPON_BIND_TIME' && (
                <Box>
                  <Box
                    fontSize="18px"
                    color="#212121"
                    fontWeight="600"
                    lineHeight="25px"
                    mt={7}
                    mb={4}
                  >
                    调整优惠券
                  </Box>
                  <Box display="flex" gap="56px" alignItems="center">
                    <Box display="flex" gap="12px" alignItems="center">
                      <Controller
                        control={control}
                        name="startTimeChecked"
                        render={(pr) => (
                          <FormControlLabel
                            {...pr}
                            label=""
                            variant="standard"
                            checked={pr.value ?? false}
                            control={<Checkbox color="primary" />}
                            onChange={(e) => {
                              pr.onChange(e.target.checked);
                            }}
                          />
                        )}
                      />
                      <Box width="154px">
                        <Controller
                          name="startTime"
                          control={control}
                          as={(pr) => {
                            return (
                              <DatePicker
                                value={pr.value ?? new Date()}
                                label="用券开始时间调整"
                                inputFormat="yyyy-MM-dd" //时间格式化
                                onChange={(newValue) => {
                                  const date =
                                    dayjs(newValue).format('YYYY-MM-DD');
                                  return pr.onChange(date);
                                }}
                                // minDate={new Date()}
                                renderInput={(params) => {
                                  return (
                                    <Box>
                                      <TextField
                                        sx={{
                                          height: 'auto',
                                          display: 'flex',
                                          alignItems: 'flex-end',
                                        }}
                                        variant="standard"
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                          placeholder: '请选择时间',
                                          readonly: 'readonly',
                                        }}
                                      />
                                    </Box>
                                  );
                                }}
                              />
                            );
                          }}
                          defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                        />
                      </Box>
                    </Box>
                    <Box display="flex" gap="12px" alignItems="center">
                      <Controller
                        control={control}
                        name="endTimeChecked"
                        render={(pr) => (
                          <FormControlLabel
                            {...pr}
                            label=""
                            variant="standard"
                            checked={pr.value ?? false}
                            control={<Checkbox color="primary" />}
                            onChange={(e) => {
                              pr.onChange(e.target.checked);
                            }}
                          />
                        )}
                      />
                      <Box width="154px">
                        <Controller
                          name="endTime"
                          control={control}
                          as={(pr) => {
                            return (
                              <DatePicker
                                label="用券结束时间调整"
                                value={pr.value ?? new Date()}
                                inputFormat="yyyy-MM-dd" //时间格式化
                                onChange={(newValue) => {
                                  const date =
                                    dayjs(newValue).format('YYYY-MM-DD');
                                  return pr.onChange(date);
                                }}
                                // minDate={new Date()}
                                renderInput={(params) => {
                                  return (
                                    <Box>
                                      <TextField
                                        sx={{
                                          height: 'auto',
                                          display: 'flex',
                                          alignItems: 'flex-end',
                                        }}
                                        variant="standard"
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                          placeholder: '请选择时间',
                                          readonly: 'readonly',
                                        }}
                                      />
                                    </Box>
                                  );
                                }}
                              />
                            );
                          }}
                          defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
              <Box width={360} mt={7}>
                <Controller
                  render={(pr) => (
                    <TextField
                      disabled={status === 'detail'}
                      onChange={(e) => {
                        return pr.onChange(e.target.value);
                      }}
                      InputProps={
                        status !== 'detail' && {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                className="clear-btn"
                                onClick={() => {
                                  setValue('remark', '');
                                }}
                                edge="end"
                              >
                                {getValues('remark') ? (
                                  <ClearIcon className="clear-icon" />
                                ) : (
                                  ''
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }
                      }
                      variant="standard"
                      className="input"
                      value={pr.value ?? ''}
                      label={
                        <>
                          <span style={{ color: 'red' }}>*</span>
                          {remarkLabel}
                        </>
                      }
                      error={Boolean(errors?.remark)}
                      helperText={(() => {
                        const error = errors?.remark?.type;
                        switch (error) {
                          case 'required':
                            return `${remarkLabel}是必填项`;
                          case 'maxLength':
                            return '输入长度最大50个字符';
                          default:
                        }
                      })()}
                    />
                  )}
                  name="remark"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: true,
                    maxLength: 50,
                  }}
                />
              </Box>
              <ButtonGroup control={control} saveRef={saveRef} />
            </Box>
          </form>
        </FormProvider>
      </Box>
    </AddStyled>
  );
};
export default Add;
